module.exports = __webpack_public_path__ + "static/media/tp_tube_snail.9310ea7f.jpg";